import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";

export const uploadImageFromGift = async (base64Image, fileName) => {
  const storage = getStorage();
  const storageRef = ref(storage, `pod-images/${fileName}`);

  // Upload base64 image string as a data URL
  await uploadString(storageRef, base64Image, 'data_url');

  // Return the download URL
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};